import React, { useMemo, useState, useRef, useLayoutEffect, useCallback, Fragment, useEffect, useContext } from 'react'
import { Table, TableBody, TableRow, Checkbox, IconButton, Grid, TextField, Select, FormControl, MenuItem, Divider, TableCell } from "@mui/material";
import { FooterText, ScrollableFooter, ScrollableTableContainer, TableCircularProgress, SiteHeadDiv, SiteHeadSpan, SiteHeadStyled } from './styled/ScrollableTable.styled';
import { BiCaretUp, BiX, BiCaretDown } from 'react-icons/bi';
import { makeStyles } from "@material-ui/core/styles";
import TableHead from "@material-ui/core/TableHead";
import { getAdvancedSiteRefs } from '../services/api/siteService';
import styled from 'styled-components';
import { WebMapContext } from '../pages/sections/web-map/WebMapGoogleMap';
import { SITEREF_TABLE_COL_KEYS } from '../constants/WebMap';

const useStyles = makeStyles(theme => ({
  tableHead: {
    backgroundColor: '#ffffff'
  },
  smallTextField: {
    width: '83px',
    "& input": {
      // paddingTop: "2.5px",
      paddingBottom: "2.5px",
      textAlign: "center",
      font: "normal normal normal 10px/14px Open Sans"
    },
  },
  smallTableRow: {
    height: '20px',
  },
  tableRow: {
    height: '10px'
  },
  tableRowWithoutLine: {
    height: '10px',
    '&:nth-child(odd)': {
      borderBottom: 'none',
    },
  },
  tableCell: {
    fontSize: '12px',
    padding: '4px',
  },
  textField: {
    width: '100%',
  },
  smallIconButton: {
    padding: '6px',
  },
  searchOpDropDown: {
    width: '83px',
    '& .kJkfJI': {
      scale: 0.8
    },
  },
  selectInput: {
    padding: 0,
    height: 'auto',
    minHeight: '1.4375em',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
  },
  cellHead: {
    fontSize: '12px',
    padding: '0px',
  },
  stickyHeader: {
    position: 'sticky',
    top: 0,
    backgroundColor: 'white',
    zIndex: 1,
  },
  stickyCell: {
    borderBottom: 'none',
  },
  stickyBorder: {
    borderBottom: '1px solid #E0E0E0',
    marginTop: '4px'
  },
}));

const CustomTableCell = styled.td`
  font-family: "Roboto","Helvetica","Arial",sans-serif;
  font-weight: 400;
  font-size: 0.875rem;
  line-height: 1.43;
  -webkit-letter-spacing: 0.01071em;
  -moz-letter-spacing: 0.01071em;
  -ms-letter-spacing: 0.01071em;
  letter-spacing: 0.01071em;
  display: table-cell;
  vertical-align: inherit;
  border-bottom: 1px solid rgba(224,224,224,1);
  text-align: center;
  padding: 2.5px;
`;

export default function ScrollableTable({
  dataRows = [],
  page = 1,
  setDataRows = () => { },
  setMasterChecked = () => { },
  masterChecked
}) {

  const {
    operatorDetails,
    selectedSiteRef,
    setSelectedSiteRef,
    appliedFilters
  } = useContext(WebMapContext);

  const { edotcoSiteAreaToggle,operatorsPermittedECSiteET } = useContext(WebMapContext);
  const tableEl = useRef()
  const classes = useStyles();

  const [pageNum, setPageNum] = useState(page)
  const [loading, setLoading] = useState(false)
  const [isFullDataLoad, setIsFullDataLoad] = useState(false)
  const [showSelectedRows, setShowSelectedRows] = useState(false)
  const [advanceSearchFilterValues, setAdvanceSearchFilterValues] = useState([]);
  const [sortParams, setSortParams] = useState([]);
  const [isClickedSort, setIsClickedSort] = useState(false);
  const [isClickedSiteRef, setIsClickedSiteRef] = useState(false);
  const [isClickedOp, setIsClickedOp] = useState(false);
  const [isClickedBDwn, setIsClickedBDwn] = useState(false);
  const [isClickedBUp, setIsClickedBUp] = useState(false);
  const [isClickedBRsrp, setIsClickedBRsrp] = useState(false);
  const [isClickedNDwn, setIsClickedNDwn] = useState(false);
  const [isClickedNUp, setIsClickedNUp] = useState(false);
  const [isClickedNRsrp, setIsClickedNRsrp] = useState(false);
  const [isClickedRDwn, setIsClickedRDwn] = useState(false);
  const [isClickedRUp, setIsClickedRUp] = useState(false);
  const [isClickedRRsrp, setIsClickedRRsrp] = useState(false);
  const [isClickedBDemand, setIsClickedBDemand] = useState(false);
  const [isClickedNDemand, setIsClickedNDemand] = useState(false);
  const [isClickedRDemand, setIsClickedRDemand] = useState(false);

  const [sortBy, setSortBy] = useState('');
  const [siteRef, setSiteRef] = useState('');
  const [op, setOp] = useState('');
  const [bsDwn, setBsDwn] = useState('');
  const [bsUp, setBsUp] = useState('');
  const [bsRsrp, setBsRsrp] = useState('');
  const [bsDemand, setBsDemand] = useState('');
  const [neighDwn, setNeighDwn] = useState('');
  const [neighUp, setNeighUp] = useState('');
  const [neighRsrp, setNeighRsrp] = useState('');
  const [neighDemand, setNeighDemand] = useState('');
  const [radisDwn, setRadisDwn] = useState('');
  const [radisUp, setRadisUp] = useState('');
  const [radisRsrp, setRadisRsrp] = useState('');
  const [radisDemand, setRadisDemand] = useState('');
  const [searchOperator, setSearchOperator] = useState('');
  const [mnoOperatorsET, setMnoOperatorsET] = useState([]);

  useEffect(() => {
    loadData(1, [], [])
  }, []);

  useEffect(() => {
    const mnoOperatorsET = operatorsPermittedECSiteET?.filter(operator => operator.type === "MNO" && operator.is_others === false && operator.operator !== "Others");
    setMnoOperatorsET(mnoOperatorsET)
  }, [operatorsPermittedECSiteET]);

  const tempConfirmedRefs = useMemo(() => {
    const list = selectedSiteRef.filter(x => !x.tempRemoved);
    return list;
  }, [selectedSiteRef]);

  const loadData = async (page, sortingOrder, advanceSearchFilterValues) => {
    setLoading(true)
    setIsFullDataLoad(false)
    let queryParams = {
      pageNum: page || 1,
      countryCode: appliedFilters.countryCode,
      quarter: appliedFilters.quarter,
      year: appliedFilters.year,
      sortParams: sortingOrder || [],
      advanceSearchKeys: advanceSearchFilterValues || [],
      adL: edotcoSiteAreaToggle && appliedFilters.level !== 'geoHashLevel' ? appliedFilters.level : null,
      adLVal: edotcoSiteAreaToggle && appliedFilters.level !== 'geoHashLevel' ? appliedFilters.levelVal : null,
    }
    const { data } = await getAdvancedSiteRefs(queryParams)
    if (data && data.length > 0) {
      const updatedData = data.map(({ siteRef, ...rest }) => ({
        siteRef,
        expand: false,
        selected: masterChecked ? true : tempConfirmedRefs.find(x => x.siteRef === siteRef) ? true : false,
        ...rest
      }));
      if (page === 1) setPageNum(1);
      if (isClickedSort) {
        applySort(sortBy, sortingOrder, updatedData, page)
      } else {
        if (page === 1) {
          setDataRows(updatedData)
        } else {
          setDataRows(prevState => [...prevState, ...updatedData]);
        }
      }
      setIsFullDataLoad(false)
    } else {
      if (page === 1) {
        setDataRows([])
      }
      setIsFullDataLoad(true)
    }
    setLoading(false)
  }

  // row-selection feature
  const onMasterCheck = (e) => {
    setMasterChecked(e.target.checked);
    if (showSelectedRows) {
      if (e.target.checked) return;
      else {
        let tempSelectedList = [...tempConfirmedRefs];
        tempSelectedList.forEach((row) => (row.tempRemoved = true)); // remove all current confirmed refs (temp)
        setSelectedSiteRef(tempSelectedList);
      }
    };
    let tempList = [...dataRows];
    tempList.forEach((row) => (row.selected = e.target.checked));
    setDataRows(tempList);
  }

  const onRowCheck = (e, item) => {
    let tempList = [...dataRows];
    const index = tempList.findIndex(x => x.siteRef === item.siteRef);
    if (index >= 0) {
      tempList[index].selected = e.target.checked;
      setDataRows(tempList);
    } else if (showSelectedRows) { // check the item is in selected window
      let tempSelectedList = [...tempConfirmedRefs];
      const idx = tempSelectedList.findIndex(x => x.siteRef === item.siteRef);
      if (idx >= 0) {
        tempSelectedList[idx].tempRemoved = true;
        setSelectedSiteRef(tempSelectedList);
      }
    }
  }

  const handleDisplaySelectedRows = async () => {
    if (showSelectedRows && masterChecked && dataRows.some(x => !x.selected)) setMasterChecked(false);
    setShowSelectedRows(!showSelectedRows)
  }

  const updateSearchFilters = (event, searchKey) => {
    if (searchKey === SITEREF_TABLE_COL_KEYS.SITE_REF) {
      setSiteRef(event.target.value || '')
    } else if (searchKey === SITEREF_TABLE_COL_KEYS.OPRTR_OP) {
      setOp(event.target.value);
    } else if (searchKey === SITEREF_TABLE_COL_KEYS.OPRTR_BS_DWN) {
      setBsDwn(event.target.value || '');
    } else if (searchKey === SITEREF_TABLE_COL_KEYS.OPRTR_BS_rsrp) {
      setBsRsrp(event.target.value || '');
    } else if (searchKey === SITEREF_TABLE_COL_KEYS.OPRTR_BS_UPL) {
      setBsUp(event.target.value || '');
    } else if (searchKey === SITEREF_TABLE_COL_KEYS.OPRTR_BS_DEMAND) {
      setBsDemand(event.target.value || '');
    } else if (searchKey === SITEREF_TABLE_COL_KEYS.OPRTR_NBR_DWN) {
      setNeighDwn(event.target.value || '');
    } else if (searchKey === SITEREF_TABLE_COL_KEYS.OPRTR_NBR_rsrp) {
      setNeighRsrp(event.target.value || '');
    } else if (searchKey === SITEREF_TABLE_COL_KEYS.OPRTR_NBR_UP) {
      setNeighUp(event.target.value || '');
    } else if (searchKey === SITEREF_TABLE_COL_KEYS.OPRTR_NBR_DEMAND) {
      setNeighDemand(event.target.value || '');
    } else if (searchKey === SITEREF_TABLE_COL_KEYS.OPRTR_RDS_DWN) {
      setRadisDwn(event.target.value || '');
    } else if (searchKey === SITEREF_TABLE_COL_KEYS.OPRTR_RDS_RSRP) {
      setRadisRsrp(event.target.value || '');
    } else if (searchKey === SITEREF_TABLE_COL_KEYS.OPRTR_RDS_DEMAND) {
      setRadisDemand(event.target.value || '');
    } else {
      setRadisUp(event.target.value || '');
    }
    let updateArray = []
    if (event.target.value) {
      updateArray = [...advanceSearchFilterValues, { key: searchKey, value: event.target.value }];
    } else {
      updateArray = advanceSearchFilterValues.filter(obj => obj.key !== searchKey);
    }
    setAdvanceSearchFilterValues(updateArray)
    return updateArray;
  };

  const handleOpFilter = async (event) => {
    setSearchOperator(event.target.value);
    setOp(event.target.value.operator);
    const updateArray = [...advanceSearchFilterValues, { key: SITEREF_TABLE_COL_KEYS.OPRTR_OP, value: event.target.value.operator }]
    setAdvanceSearchFilterValues(updateArray)
    await loadData(1, sortParams, updateArray)
  };

  const handleSearchClear = async (event, searchKey) => {
    let updateFilterArray = updateSearchFilters(event, searchKey)
    if (updateFilterArray.length !== 0) {
      await loadData(1, sortParams, updateFilterArray)
    } else {
      await loadData(1, [], [])
    }
  };

  const searchFilter = async (event, searchKey) => {
    let updateFilterArray = updateSearchFilters(event, searchKey)
    await loadData(1, sortParams, updateFilterArray)
  };

  // sorting feature
  const onHandleSortBySiteRef = async (sortBy, sortOrder) => {
    setSortBy(sortBy)
    setIsClickedSort(false)
    setIsClickedSiteRef(!isClickedSiteRef)
    const updateSortArray = [{ sortingName: sortBy, orderType: sortOrder, order: '1' }]
    setSortParams(updateSortArray)
    await loadData(1, updateSortArray, advanceSearchFilterValues)
  }

  const sortOprtrArray = (oprtrArray, sortBy, sortOrder) => {
    const fieldArray = sortBy.split(".");
    const field = fieldArray[fieldArray.length - 1];
    return oprtrArray.slice().sort((a, b) => {
      const valueA = a[field];
      const valueB = b[field];

      if (sortBy !== SITEREF_TABLE_COL_KEYS.OPRTR_OP) {
        // Handle empty strings or non-numeric values
        if (typeof valueA !== 'number' || isNaN(valueA)) {
          return sortOrder === 'asc' ? -1 : 1;
        }
        if (typeof valueB !== 'number' || isNaN(valueB)) {
          return sortOrder === 'asc' ? 1 : -1;
        }
      }
      if (sortOrder === 'asc') {
        return valueA - valueB;

      } else {
        return valueB - valueA;
      }
    });
  };

  const sortOpInOprtrArray = (oprtrArray, sortBy, sortOrder) => {
    if (sortOrder === 'asc') {
      return oprtrArray.sort((a, b) => a.op_name.localeCompare(b.op_name));
    } else {
      return oprtrArray.sort((a, b) => b.op_name.localeCompare(a.op_name));
    }
  }

  const onHandleSort = async (sortBy, sortOrder) => {
    setSortBy(sortBy)
    setIsClickedSort(true)
    setIsClickedOp(sortBy === SITEREF_TABLE_COL_KEYS.OPRTR_OP ? !isClickedOp : isClickedOp)
    setIsClickedBDwn(sortBy === SITEREF_TABLE_COL_KEYS.OPRTR_BS_DWN ? !isClickedBDwn : isClickedBDwn)
    setIsClickedBUp(sortBy === SITEREF_TABLE_COL_KEYS.OPRTR_BS_UPL ? !isClickedBUp : isClickedBUp)
    setIsClickedBRsrp(sortBy === SITEREF_TABLE_COL_KEYS.OPRTR_BS_rsrp ? !isClickedBRsrp : isClickedBRsrp)
    setIsClickedBDemand(sortBy === SITEREF_TABLE_COL_KEYS.OPRTR_BS_DEMAND ? !isClickedBDemand : isClickedBDemand)
    setIsClickedNDwn(sortBy === SITEREF_TABLE_COL_KEYS.OPRTR_NBR_DWN ? !isClickedNDwn : isClickedNDwn)
    setIsClickedNUp(sortBy === SITEREF_TABLE_COL_KEYS.OPRTR_NBR_UP ? !isClickedNUp : isClickedNUp)
    setIsClickedNRsrp(sortBy === SITEREF_TABLE_COL_KEYS.OPRTR_NBR_rsrp ? !isClickedNRsrp : isClickedNRsrp)
    setIsClickedNDemand(sortBy === SITEREF_TABLE_COL_KEYS.OPRTR_NBR_DEMAND ? !isClickedNDemand : isClickedNDemand)
    setIsClickedRDwn(sortBy === SITEREF_TABLE_COL_KEYS.OPRTR_RDS_DWN ? !isClickedRDwn : isClickedRDwn)
    setIsClickedRUp(sortBy === 'oprtr.rdis_up' ? !isClickedRUp : isClickedRUp)
    setIsClickedRRsrp(sortBy === SITEREF_TABLE_COL_KEYS.OPRTR_RDS_RSRP ? !isClickedRRsrp : isClickedRRsrp)
    setIsClickedRDemand(sortBy === SITEREF_TABLE_COL_KEYS.OPRTR_RDS_DEMAND ? !isClickedRDemand : isClickedRDemand)

    const updateSortArray = [{ sortingName: sortBy, orderType: sortOrder, order: '1' }]
    setSortParams(updateSortArray)

    const sortedData = dataRows.map(item => {
      let sortedOprtr;
      if (sortBy === SITEREF_TABLE_COL_KEYS.OPRTR_OP) {
        const reArrangedOprtr = item.oprtr.map(obj => {
          const matchedItem = mnoOperatorsET?.find(item => item.key === obj.op);
          if (matchedItem) {
            return { ...obj, op_name: matchedItem.value };
          }
          return { ...obj, op_name: obj.op };
        });

        sortedOprtr = sortOpInOprtrArray(reArrangedOprtr, sortBy, sortOrder);
        return { ...item, oprtr: sortedOprtr };
      } else {
        sortedOprtr = sortOprtrArray(item.oprtr, sortBy, sortOrder);
        return { ...item, oprtr: sortedOprtr };
      }

    });
    setDataRows(sortedData)
  }

  const applySort = async (sortBy, sortOrder, tempList, page) => {
    let sortedData = []
    let sortedOprtr = []
    if (sortBy === SITEREF_TABLE_COL_KEYS.OPRTR_OP) {
      sortedData = tempList.map(item => {
        const reArrangedOprtr = item.oprtr.map(obj => {
          const matchedItem = mnoOperatorsET?.find(item => item.key === obj.op);
          if (matchedItem) {
            return { ...obj, op_name: matchedItem.value };
          }
          return { ...obj, op_name: obj.op };
        });

        sortedOprtr = sortOpInOprtrArray(reArrangedOprtr, sortBy, sortOrder);
        return { ...item, oprtr: sortedOprtr };
      });

    } else {
      sortedData = tempList.map(item => {
        const sortedOprtr = sortOprtrArray(item.oprtr, sortBy, sortOrder);
        return { ...item, oprtr: sortedOprtr };
      });
    }
    if (page === 1) {
      setDataRows(sortedData)
    } else {
      setDataRows(prevState => [...prevState, ...sortedData])
    }
  }

  const tempSelectedSiteRefs = useMemo(() => {
    const result = [];
    tempConfirmedRefs.forEach(selectedRow => {
      const matchingRow = dataRows.find(row => row.siteRef === selectedRow.siteRef);
      if (matchingRow) {
        if (matchingRow.selected) {
          result.push(selectedRow);
        }
      } else {
        result.push(selectedRow);
      }
    });
    dataRows.forEach(row => {
      const matchingSelectedRow = tempConfirmedRefs.find(selectedRow => selectedRow.siteRef === row.siteRef);
      if (row.selected && !matchingSelectedRow) {
        result.push(row);
      }
    });
    return result;
  }, [tempConfirmedRefs, dataRows]);

  // table infinite load feature
  const loadMore = useCallback(() => {
    const loadItems = async () => {
      const newPageNum = pageNum + 1
      await loadData(newPageNum, sortParams, advanceSearchFilterValues)
      setPageNum(newPageNum)
    }
    loadItems()
  })

  const scrollListener = useCallback(() => {
    const tableRef = tableEl.current;
    const bottom = tableRef.scrollHeight - tableRef.clientHeight;
    const distanceBottomPercentage = 0.2; // Adjust this value as needed (e.g., 0.2 for 20% of the table's height)
    const distanceBottom = tableRef.clientHeight * distanceBottomPercentage;
    if (tableRef.scrollTop > bottom - distanceBottom && !loading && !showSelectedRows && !isFullDataLoad) {
      loadMore();
    }
  }, [loadMore, loading, showSelectedRows, isFullDataLoad]);

  useLayoutEffect(() => {
    const tableRef = tableEl.current
    tableRef.addEventListener('scroll', scrollListener)
    return () => {
      tableRef.removeEventListener('scroll', scrollListener)
    }
  }, [scrollListener, loadMore, loading, showSelectedRows, isFullDataLoad])

  const renderFields = (searchLabelName, searchKeyType, inputValue) => {
    return <CustomTableCell className={`${(searchKeyType === "siteRef" || searchKeyType === "oprtr.op"
      || searchKeyType === "oprtr.bs_upl" || searchKeyType === "oprtr.nghbr_up") ? "verticalDivider" : ""} ${classes.stickyCell}`}>
      {searchKeyType === SITEREF_TABLE_COL_KEYS.OPRTR_OP ?
        <>
          <FormControl className={`${classes.searchOpDropDown}`}>
            <Select
              value={searchOperator}
              onChange={handleOpFilter}
              displayEmpty
              inputProps={{ 'aria-label': 'Without label' }}
              disabled={showSelectedRows}
              classes={{ select: classes.selectInput }}
              renderValue={() => {
                const selectedItem = mnoOperatorsET?.find(item => item.operator === searchOperator.operator);
                if (selectedItem) {
                  return <span style={{ fontSize: '12px' }}>{selectedItem.name}</span>;
                }
                return <em style={{ fontSize: '12px', color: '#E4E4E4' }}>Select</em>;
              }}
            >
              <MenuItem value="" style={{ fontSize: '12px' }}>
                Any
              </MenuItem>
              {mnoOperatorsET?.map(item => (
                <MenuItem key={item.operator} value={item} style={{ fontSize: '12px' }}>
                  {item.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </>
        :
        <TextField
          className={classes.smallTextField}
          id={`outlined-basic-${searchKeyType}`}
          placeholder={searchLabelName}
          value={inputValue}
          variant="outlined"
          onChange={(e) => updateSearchFilters(e, searchKeyType)}
          disabled={showSelectedRows}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
              searchFilter(e, searchKeyType);
            }
          }}
          InputProps={{
            endAdornment:
              advanceSearchFilterValues.length !== 0 ? (
                <IconButton
                  className={classes.smallIconButton}
                  onClick={(e) => handleSearchClear(e, searchKeyType)}
                >
                  <BiX style={{ fontSize: "small", color: "gray" }} />
                </IconButton>
              ) : <></>
          }}
          size="small"
        />
      }

    </CustomTableCell>
  };

  const sortButton = (sortBy, order) => {
    return (
      sortBy === SITEREF_TABLE_COL_KEYS.SITE_REF ?
        order === 'asc' ?
          <IconButton className={classes.smallIconButton} onClick={() => { onHandleSortBySiteRef(sortBy, order); }} disabled={showSelectedRows}>
            <BiCaretUp style={{ fontSize: "small", color: "gray" }} />
          </IconButton>
          :
          <IconButton className={classes.smallIconButton} onClick={() => { onHandleSortBySiteRef(sortBy, order); }} disabled={showSelectedRows}>
            <BiCaretDown style={{ fontSize: "small", color: "gray" }} />
          </IconButton>
        :
        order === 'asc' ?
          <IconButton className={classes.smallIconButton} onClick={() => { onHandleSort(sortBy, order); }} disabled={showSelectedRows}>
            <BiCaretUp style={{ fontSize: "small", color: "gray" }} />
          </IconButton>
          :
          <IconButton className={classes.smallIconButton} onClick={() => { onHandleSort(sortBy, order); }} disabled={showSelectedRows}>
            <BiCaretDown style={{ fontSize: "small", color: "gray" }} />
          </IconButton>
    );
  }

  const CustomHeadCell = ({ children, verticalEnable, colSpan, isHide = false }) => (
    <CustomTableCell colSpan={colSpan || 0} className={`${classes.cellHead} ${classes.stickyCell} ${verticalEnable ? 'verticalDivider' : ''}`} align="center" >
      <SiteHeadDiv>
        <SiteHeadSpan isHide={isHide}>
          {children}
        </SiteHeadSpan>
        <Divider className={classes.stickyBorder} orientation="horizontal" />
      </SiteHeadDiv>
    </CustomTableCell>
  );

  return (
    <>
      <ScrollableTableContainer ref={tableEl}>
        {loading && <TableCircularProgress />}
        <Table>
          <TableHead className={`${classes.tableHead} ${classes.stickyHeader}`}>
            <TableRow className={`${classes.tableRow}`}>
              <CustomHeadCell colSpan={3} verticalEnable={true} isHide={true}>none</CustomHeadCell>
              <CustomHeadCell colSpan={4} verticalEnable={true}>Base Geohash</CustomHeadCell>
              <CustomHeadCell colSpan={4} verticalEnable={true}>Neighbor Geohash</CustomHeadCell>
              <CustomHeadCell colSpan={4}>Site Radius</CustomHeadCell>
            </TableRow>

            <TableRow className={classes.tableRow}>
              <CustomHeadCell>
                <Checkbox
                  checked={masterChecked}
                  onChange={(e) => onMasterCheck(e)}
                />
              </CustomHeadCell>
              <CustomHeadCell>
                <div>
                  <div align="center">Site Ref</div>
                  <div align="center">{isClickedSiteRef ? sortButton(SITEREF_TABLE_COL_KEYS.SITE_REF, 'asc') : sortButton(SITEREF_TABLE_COL_KEYS.SITE_REF, 'desc')}</div>
                </div>
              </CustomHeadCell>
              <CustomHeadCell verticalEnable={true}>
                <div>
                  <div align="center">Operator</div>
                  <div align="center">{isClickedOp ? sortButton(SITEREF_TABLE_COL_KEYS.OPRTR_OP, 'asc') : sortButton(SITEREF_TABLE_COL_KEYS.OPRTR_OP, 'desc')}</div>
                </div>
              </CustomHeadCell>
              <CustomHeadCell>
                <SiteHeadStyled>
                  <div align="left">Demand </div>
                  <div align="left">Score{(sortBy === SITEREF_TABLE_COL_KEYS.OPRTR_BS_DEMAND && isClickedBDemand) ? sortButton(SITEREF_TABLE_COL_KEYS.OPRTR_BS_DEMAND, 'asc') : sortButton(SITEREF_TABLE_COL_KEYS.OPRTR_BS_DEMAND, 'desc')}</div>
                </SiteHeadStyled>
              </CustomHeadCell>
              <CustomHeadCell>
                <SiteHeadStyled>
                  <div align="left">RSRP </div>
                  <div align="left">(dbm){(sortBy === SITEREF_TABLE_COL_KEYS.OPRTR_BS_rsrp && isClickedBRsrp) ? sortButton(SITEREF_TABLE_COL_KEYS.OPRTR_BS_rsrp, 'asc') : sortButton(SITEREF_TABLE_COL_KEYS.OPRTR_BS_rsrp, 'desc')}</div>
                </SiteHeadStyled>
              </CustomHeadCell>
              <CustomHeadCell>
                <SiteHeadStyled>
                  <div align="left">Download </div>
                  <div align="left">(Mbps){(sortBy === SITEREF_TABLE_COL_KEYS.OPRTR_BS_DWN && isClickedBDwn) ? sortButton(SITEREF_TABLE_COL_KEYS.OPRTR_BS_DWN, 'asc') : sortButton(SITEREF_TABLE_COL_KEYS.OPRTR_BS_DWN, 'desc')}</div>
                </SiteHeadStyled>
              </CustomHeadCell>
              <CustomHeadCell verticalEnable={true}>
                <SiteHeadStyled>
                  <div align="left">Upload </div>
                  <div align="left">(Mbps){(sortBy === SITEREF_TABLE_COL_KEYS.OPRTR_BS_UPL && isClickedBUp) ? sortButton(SITEREF_TABLE_COL_KEYS.OPRTR_BS_UPL, 'asc') : sortButton(SITEREF_TABLE_COL_KEYS.OPRTR_BS_UPL, 'desc')}</div>
                </SiteHeadStyled>
              </CustomHeadCell>
              <CustomHeadCell>
                <SiteHeadStyled>
                  <div align="left">Demand </div>
                  <div align="left">Score{(sortBy === SITEREF_TABLE_COL_KEYS.OPRTR_NBR_DEMAND && isClickedNDemand) ? sortButton(SITEREF_TABLE_COL_KEYS.OPRTR_NBR_DEMAND, 'asc') : sortButton(SITEREF_TABLE_COL_KEYS.OPRTR_NBR_DEMAND, 'desc')}</div>
                </SiteHeadStyled>
              </CustomHeadCell>
              <CustomHeadCell>
                <SiteHeadStyled>
                  <div align="left">RSRP </div>
                  <div align="left">(dbm){(sortBy === SITEREF_TABLE_COL_KEYS.OPRTR_NBR_rsrp && isClickedNRsrp) ? sortButton(SITEREF_TABLE_COL_KEYS.OPRTR_NBR_rsrp, 'asc') : sortButton(SITEREF_TABLE_COL_KEYS.OPRTR_NBR_rsrp, 'desc')}</div>
                </SiteHeadStyled>
              </CustomHeadCell>
              <CustomHeadCell>
                <SiteHeadStyled>
                  <div align="left">Download </div>
                  <div align="left">(Mbps){(sortBy === SITEREF_TABLE_COL_KEYS.OPRTR_NBR_DWN && isClickedNDwn) ? sortButton(SITEREF_TABLE_COL_KEYS.OPRTR_NBR_DWN, 'asc') : sortButton(SITEREF_TABLE_COL_KEYS.OPRTR_NBR_DWN, 'desc')}</div>
                </SiteHeadStyled>
              </CustomHeadCell>
              <CustomHeadCell verticalEnable={true}>
                <SiteHeadStyled>
                  <div align="left">Upload </div>
                  <div align="left">(Mbps){(sortBy === SITEREF_TABLE_COL_KEYS.OPRTR_NBR_UP && isClickedNUp) ? sortButton(SITEREF_TABLE_COL_KEYS.OPRTR_NBR_UP, 'asc') : sortButton(SITEREF_TABLE_COL_KEYS.OPRTR_NBR_UP, 'desc')}</div>
                </SiteHeadStyled>
              </CustomHeadCell>
              <CustomHeadCell>
                <SiteHeadStyled>
                  <div align="left">Demand </div>
                  <div align="left">Score{(sortBy === SITEREF_TABLE_COL_KEYS.OPRTR_RDS_DEMAND && isClickedRDemand) ? sortButton(SITEREF_TABLE_COL_KEYS.OPRTR_RDS_DEMAND, 'asc') : sortButton(SITEREF_TABLE_COL_KEYS.OPRTR_RDS_DEMAND, 'desc')}</div>
                </SiteHeadStyled>
              </CustomHeadCell>
              <CustomHeadCell>
                <SiteHeadStyled>
                  <div align="left">RSRP </div>
                  <div align="left">(dbm){(sortBy === SITEREF_TABLE_COL_KEYS.OPRTR_RDS_RSRP && isClickedRRsrp) ? sortButton(SITEREF_TABLE_COL_KEYS.OPRTR_RDS_RSRP, 'asc') : sortButton(SITEREF_TABLE_COL_KEYS.OPRTR_RDS_RSRP, 'desc')}</div>
                </SiteHeadStyled>
              </CustomHeadCell>
              <CustomHeadCell>
                <SiteHeadStyled>
                  <div align="left">Download </div>
                  <div align="left">(Mbps){(sortBy === SITEREF_TABLE_COL_KEYS.OPRTR_RDS_DWN && isClickedRDwn) ? sortButton(SITEREF_TABLE_COL_KEYS.OPRTR_RDS_DWN, 'asc') : sortButton(SITEREF_TABLE_COL_KEYS.OPRTR_RDS_DWN, 'desc')}</div>
                </SiteHeadStyled>
              </CustomHeadCell>
              <CustomHeadCell>
                <SiteHeadStyled>
                  <div align="left">Upload </div>
                  <div align="left">(Mbps){(sortBy === 'oprtr.rdis_up' && isClickedRUp) ? sortButton('oprtr.rdis_up', 'asc') : sortButton('oprtr.rdis_up', 'desc')}</div>
                </SiteHeadStyled>
              </CustomHeadCell>
            </TableRow>

            <TableRow className={classes.tableRow}>
              <CustomTableCell className={classes.stickyCell}></CustomTableCell>
              {renderFields('Search...', SITEREF_TABLE_COL_KEYS.SITE_REF, siteRef)}
              {renderFields('Search...', SITEREF_TABLE_COL_KEYS.OPRTR_OP, op)}
              {renderFields('', SITEREF_TABLE_COL_KEYS.OPRTR_BS_DEMAND, bsDemand)}
              {renderFields('', SITEREF_TABLE_COL_KEYS.OPRTR_BS_rsrp, bsRsrp)}
              {renderFields('', SITEREF_TABLE_COL_KEYS.OPRTR_BS_DWN, bsDwn)}
              {renderFields('', SITEREF_TABLE_COL_KEYS.OPRTR_BS_UPL, bsUp)}
              {renderFields('', SITEREF_TABLE_COL_KEYS.OPRTR_NBR_DEMAND, neighDemand)}
              {renderFields('', SITEREF_TABLE_COL_KEYS.OPRTR_NBR_rsrp, neighRsrp)}
              {renderFields('', SITEREF_TABLE_COL_KEYS.OPRTR_NBR_DWN, neighDwn)}
              {renderFields('', SITEREF_TABLE_COL_KEYS.OPRTR_NBR_UP, neighUp)}
              {renderFields('', SITEREF_TABLE_COL_KEYS.OPRTR_RDS_DEMAND, radisDemand)}
              {renderFields('', SITEREF_TABLE_COL_KEYS.OPRTR_RDS_RSRP, radisRsrp)}
              {renderFields('', SITEREF_TABLE_COL_KEYS.OPRTR_RDS_DWN, radisDwn)}
              {renderFields('', 'oprtr.rdis_up', radisUp)}
            </TableRow>
            <TableRow>
              <TableCell colSpan={15} className={classes.stickyCell} sx={{ padding: "0px" }}>
                <Divider sx={{ borderBottom: '1px solid #E0E0E0' }} orientation="horizontal" />
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {(showSelectedRows ? tempSelectedSiteRefs : dataRows).map(item => (
              <Fragment>
                <TableRow>
                  <CustomTableCell padding="checkbox" rowSpan={item?.oprtr?.length + 1}>
                    <Checkbox
                      onClick={event => onRowCheck(event, item)}
                      checked={item['selected']}
                    />
                  </CustomTableCell>
                  <CustomTableCell className={`${classes.tableCell} verticalDivider`} rowSpan={item?.oprtr?.length + 1}>
                    {item?.siteRef}
                  </CustomTableCell>
                </TableRow>

                {item.oprtr.map(detail => (
                  <TableRow>
                    <CustomTableCell className={`${classes.tableCell} verticalDivider`} align="center" style={{ "text-align": 'left' }}>
                      {detail?.op ? (
                        mnoOperatorsET?.find(obj => obj.operator === detail.op)?.name || '-'
                      ) : '-'}
                    </CustomTableCell>
                    <CustomTableCell className={`${classes.tableCell}`}>{detail?.bs_demand ? detail?.bs_demand : '-'}</CustomTableCell>
                    <CustomTableCell className={`${classes.tableCell}`} align="center">{detail?.bs_rsrp ? detail.bs_rsrp : '-'}</CustomTableCell>
                    <CustomTableCell className={`${classes.tableCell}`} align="center">{detail?.bs_dwn ? detail.bs_dwn : '-'}</CustomTableCell>
                    <CustomTableCell className={`${classes.tableCell} verticalDivider`} align="center">{detail?.bs_upl ? detail.bs_upl : '-'}</CustomTableCell>
                    <CustomTableCell className={`${classes.tableCell}`}>{detail?.nghbr_demand ? detail?.nghbr_demand : '-'}</CustomTableCell>
                    <CustomTableCell className={`${classes.tableCell}`} align="center">{detail?.nghbr_rsrp ? detail.nghbr_rsrp : '-'}</CustomTableCell>
                    <CustomTableCell className={`${classes.tableCell}`} align="center">{detail?.nghbr_dwn ? detail.nghbr_dwn : '-'}</CustomTableCell>
                    <CustomTableCell className={`${classes.tableCell} verticalDivider`} align="center">{detail?.nghbr_up ? detail.nghbr_up : '-'}</CustomTableCell>
                    <CustomTableCell className={`${classes.tableCell}`}>{detail?.rdis_demand ? detail?.rdis_demand : '-'}</CustomTableCell>
                    <CustomTableCell className={`${classes.tableCell}`} align="center">{detail?.rdis_rsrp ? detail.rdis_rsrp : '-'}</CustomTableCell>
                    <CustomTableCell className={`${classes.tableCell}`} align="center">{detail?.rdis_dwn ? detail.rdis_dwn : '-'}</CustomTableCell>
                    <CustomTableCell className={`${classes.tableCell}`} align="center">{detail?.rdis_up ? detail.rdis_up : '-'}</CustomTableCell>
                  </TableRow>
                ))}
              </Fragment>
            ))}
          </TableBody>
        </Table>
      </ScrollableTableContainer >

      <Grid container justifyContent="space-between">
        <Grid item xs={6}>
          <ScrollableFooter textAlign="left">
            {showSelectedRows ? (
              <FooterText isClickable={true} color='#006F35' onClick={handleDisplaySelectedRows}>
                Back
              </FooterText>
            ) : (
              <>
                {tempSelectedSiteRefs.length > 0 ?
                  <><FooterText isClickable={true} color='#006F35' onClick={handleDisplaySelectedRows}>
                    {`${tempSelectedSiteRefs.length} rows`}
                  </FooterText><FooterText>{" selected"}</FooterText></> : ''
                }
              </>
            )}
          </ScrollableFooter>

        </Grid>
        <Grid item xs={6}>
          <ScrollableFooter textAlign="right">{`Showing ${showSelectedRows ? tempSelectedSiteRefs.length : dataRows?.length} entries`}</ScrollableFooter>
        </Grid>
      </Grid>
    </>
  )
}
